// 封装File,与element-ui el-upload的file-list格式相同

function setInitImg(blob, name) {
  var result = {}
  // Blob 转url
  var url = window.URL.createObjectURL(blob)
  // Blob 转File
  var file = new window.File([blob], name, { type: blob.type })
  result.name = name
  result.originFileObj = file
  result.url = url
  result.size = file.size
  return result
}

export {
  setInitImg
}
